export { default } from './SWSectionFAQs';
